(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nd-countdown')) {
    class NdCountdown extends HTMLElement {
      connectedCallback() {
        this.bar = this.closest('.nd-countdown-bar');
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.values[el.dataset.unit] = el));
        this.target = this.getTarget();
        if (!this.target) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      getTarget() {
        if (this.dataset.mode === 'daily') return this.endOfDay();
        // Accepts "YYYY-MM-DD" or "YYYY-MM-DD HH:MM" in the shopper's local time.
        const raw = (this.dataset.end || '').trim().replace(' ', 'T');
        const date = new Date(raw.length === 10 ? `${raw}T23:59:59` : raw);
        return isNaN(date) ? null : date;
      }

      endOfDay() {
        const end = new Date();
        end.setHours(23, 59, 59, 999);
        return end;
      }

      tick() {
        let remaining = this.target - Date.now();
        if (remaining <= 0) {
          if (this.dataset.mode === 'daily') {
            this.target = this.endOfDay();
            remaining = Math.max(0, this.target - Date.now());
          } else {
            clearInterval(this.timer);
            remaining = 0;
            if (this.dataset.hideOnEnd === 'true' && this.bar) this.bar.hidden = true;
          }
        }
        const s = Math.floor(remaining / 1000);
        this.render({
          days: Math.floor(s / 86400),
          hours: Math.floor((s % 86400) / 3600),
          minutes: Math.floor((s % 3600) / 60),
          seconds: s % 60,
        });
      }

      render(parts) {
        Object.entries(parts).forEach(([unit, value]) => {
          if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
        });
      }
    }
    customElements.define('nd-countdown', NdCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nd-sticky-atc')) {
    class NdStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-submit]');
        this.target = document.querySelector('product-info .product-form__submit');
        if (!this.target) return;

        this.button.addEventListener('click', () => {
          const submit = document.querySelector('product-info .product-form__submit');
          if (submit && !submit.disabled) submit.click();
          else submit?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        this.observer = new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', passed);
          this.setAttribute('aria-hidden', String(!passed));
          this.button.tabIndex = passed ? 0 : -1;
        });
        this.observer.observe(this.target);
        this.renderDeliveryDate();

        // Expose the bar height so the footer can reserve space and never sit underneath it.
        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--nd-sticky-atc-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }

      renderDeliveryDate() {
        const el = this.querySelector('[data-delivery-date]');
        if (!el) return;
        const addBusinessDays = (days) => {
          const date = new Date();
          let added = 0;
          while (added < days) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) added++;
          }
          return date;
        };
        const format = new Intl.DateTimeFormat(this.dataset.locale || undefined, { day: 'numeric', month: 'short' });
        const min = parseInt(this.dataset.minDays, 10);
        const max = parseInt(this.dataset.maxDays, 10);
        el.textContent =
          min === max
            ? format.format(addBusinessDays(max))
            : `${format.format(addBusinessDays(min))} – ${format.format(addBusinessDays(max))}`;
      }
    }
    customElements.define('nd-sticky-atc', NdStickyAtc);
  }

  } catch(e) { console.error(e); }
})();
})();
